export const userPrivilegesSelector = state => state.user.userPrivileges;
export const userDetailSelector = state => state.user.detail;
